import PtoAiLogo from 'url:../assets/pto-ai-logo.svg';
import { MultiClientConfigKey } from '../../common/types/multi-client.types';
import { PlatformMultiClientConfigForClient } from './multi-client-config.types';

export type PlatformMultiClientsConfigForClient = Record<MultiClientConfigKey, PlatformMultiClientConfigForClient>;

export const platformMultiClientConfigForClient: PlatformMultiClientsConfigForClient = {
  sanofi: {
    pageTitle: 'Account Updates',
    logo: 'accountUpdates',
    topNav: {
      hideAppsIcon: true,
      iconColor: 'text-slate-600',
    },
  },
  nestle: {
    pageTitle: 'PS Access',
    logo: 'psAccess',
    topNav: {
      iconColor: 'text-slate-600',
    },
  },
  payersciences: {
    pageTitle: 'PS Access',
    logo: 'psAccess',
    topNav: {
      iconColor: 'text-slate-600',
    },
  },
  demo: {
    hideMainBarAppIcons: true,
    pageTitle: 'PS Access',
    logo: 'psAccess',
    topNav: {
      iconColor: 'text-[#1F4388]',
      customLogo: PtoAiLogo as string,
    },
    buttonPrimaryClassName: 'primary default bg-ps-blue text-white focus:ring-ps-blue hover:bg-ps-blue-dark',
  },
};
